<div class="flex h-screen min-w-[1200px] bg-slate-50 overflow-x-auto">
  @if (showSidebar()) {
  <app-sidebar [isAdmin]="keycloak.hasRealmRole('Admin')" (logout)="logout()" />
  }
  <div class="flex-1 min-w-0 overflow-auto @container">
    <router-outlet />
  </div>
</div>
<p-confirmdialog styleClass="w-96" />
<p-toast position="bottom-center" [hidden]="serverErrorDialog.visible()" [life]="5000" />
<p-dialog
  header="An unexpected error occurred"
  maskStyleClass="backdrop-blur-md"
  styleClass="w-1/4"
  [closeOnEscape]="false"
  [draggable]="false"
  [modal]="true"
  [resizable]="false"
  [visible]="serverErrorDialog.visible()"
  (visibleChange)="serverErrorDialog.visible.set($event)">
  <p class="mb-4">
    We encountered an issue while processing your request. Please try again in a few moments. If the issue persists,
    contact support for assistance.
  </p>
  <div class="flex justify-end">
    <p-button label="Okay" styleClass="psg-secondary-button" (click)="serverErrorDialog.visible.set(false)" />
  </div>
</p-dialog>
